import { createStyles, rem } from "@mantine/core";

export const useStyles = createStyles(() => ({
  message: {
    fontSize: rem(16),
    textAlign: "center",
    lineHeight: 1.5,
    maxWidth: rem(400),
  },
}));
